
import { defineComponent, ref, reactive, watch, nextTick, onMounted, onBeforeUnmount, getCurrentInstance } from 'vue'
import { mapState, useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'

import COVERAPP from '@/utils/COVERAPP'

export default defineComponent({
    computed: {
        ...mapState(['activityData'])
    },
    setup (props, context) {
        const $store = useStore()
        const _this = getCurrentInstance() as any
        const COVER = _this.proxy.$common
        const $router = useRouter()
        const webviewUrl = String(useRoute().query.url)

        const getSize = () => {
            const page = document.querySelector('.page-webview') as HTMLDivElement
            page.style.height = window.innerHeight + 'px'
        }

        const id = useRoute().query.id
        const back = () => {
            $router.replace(`/speakers/${id}`)
        }

        const load = () => {
            setTimeout(() => {
                COVER.pageLoaded()
            }, 2000)
        }

        onBeforeUnmount(() => {
            window.removeEventListener('resize', getSize)
        })
       
        onMounted(() => {
            COVER.track('load', '新闻详情') 
            load()
            getSize()
            window.addEventListener('resize', getSize)
            COVER.onshare($store.state.shareData)
        })    

        return {
            webviewUrl,
            back,
            load
        }
    }
})
